/**
 * A filter function to tell typescript that the array will have non null values
 * @param value T
 * @returns NonNullable<T>
 */
export const nonNullable = <T>(value: T): value is NonNullable<T> => {
  return value !== null && value !== undefined
}
